import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import CinemaSVG from 'components/CinemaSVG/CinemaSVG';
import VisualEffect from 'components/VisualEffect/VisualEffect';
import Accessible from '../../assets/accessibleRoom.svg';
import './purchase-modal.scss';


class PurchaseModal extends Component {
  state = {}

  static getDerivedStateFromProps(nextProps, prevState) {
    const cinemaLink = nextProps.cinemas.find(cinema => cinema.link === prevState.link);
    if (!cinemaLink) {
      return {
        index: 0,
        link: nextProps.cinemas[0].link,
      };
    }
    return null;
  }

  checkDisabledSchedule = (date) => {
    const { hours, minutes, selectedDate } = this.props;
    if (selectedDate === moment().format('YYYYMMDD')) {
      if (hours && minutes) {
        const movieDate = moment({
          hours: date.split(':')[0],
          minutes: date.split(':')[1],
        });
        const dateNow = moment({
          hours: hours.toString(),
          minutes: minutes.toString(),
        });
        const dateNowPlusHalfHour = dateNow.add({ minutes: '30' });
        const isBefore = movieDate.isBefore(dateNowPlusHalfHour);
        return isBefore ? ' disabled' : '';
      }
    }
    return '';
  }

  cinemaReplacer = (name) => {
    let result = name;
    if (name.includes('artmozi')) {
      result = name.replace('artmozi', '');
    } else if (name.includes('Távmozi')) {
      result = name;
    } else if (name.includes('mozi')) {
      result = name.replace('mozi', '');
    } else if (name.includes('Mozi')) {
      result = name.replace('Mozi', '');
    }
    return result;
  };

  render() {
    const { maxWidth, color, bColor, playtime, cinemas, active, inverz, handleClick, width, brandClass } = this.props;
    return (
      <div className={`react-purchase-container${this.checkDisabledSchedule(playtime)}${width <= 992 ? ' mobile' : ''}`}>
        {active
          && (
            <div
              className={`react-purchase-modal-container${width <= 992 ? ' mobile' : ''}`}
              style={
                inverz
                  ? {
                    border: '2px solid #FFFFFF',
                    minWidth: width <= 992 ? '100vw' : '460px',
                  }
                  : {
                    minWidth: width <= 992 ? '100vw' : '460px',
                  }
              }
            >
              {cinemas.length > 1 && <button type="button" className="react-purchase-modal-item">VÁLASSZ MOZIT!</button>}
              {cinemas.map((cinema, index) => (
                <button
                  type="button"
                  key={index.toString()}
                  className={this.state.index === index ? 'react-purchase-modal-item react-purchase-active' : 'react-purchase-modal-item'}
                  onClick={(event) => {
                    event.stopPropagation();
                    this.setState({
                      index,
                      link: cinema.link,
                    });
                  }
                  }
                  tabIndex={index.toString()}
                >
                  <div className="react-purchase-active-modal-container" style={{ width: '100%' }}>
                    <div className="react-cinema-name">
                      <div className="react-cinema-title">
                        <CinemaSVG cinema={cinema.logo} />
                        <div>
                          {this.cinemaReplacer(cinema.name)}
                          <span style={{ fontFamily: 'pangram-regular', marginLeft: '4px' }}>{cinema.cinema_room}</span>
                        </div>
                      </div>
                      {width >= 992 ? <div className="react-dubsub">{`(${cinema.dubSub})`}</div> : null}
                      <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        {
                          cinema.accessible
                            ? (
                              <div style={{ height: '17px', width: '26px', flexShrink: '0', paddingBottom: '8px' }}>
                                <Accessible />
                              </div>
                            ) : null
                        }
                        <div style={{ height: '17px', width: '26px', flexShrink: '0' }}>
                          <VisualEffect effect={cinema.visualEffect} />
                        </div>
                      </div>
                    </div>
                    {width <= 992 ? <div className="react-dubsub mobile">{`(${cinema.dubSub})`}</div> : null}
                  </div>
                </button>
              ))}
              <button
                type="button"
                className="react-purchase-modal-item react-last"
                onClick={() => window.open(this.state.link, '_blank')}
                tabIndex={0}
              >
                Jegyvásárlás/foglalás
              </button>
            </div>
          )
        }
        <button
          type="button"
          className={`react-purchase-content react-mozi-brand ${!active ? brandClass : `${brandClass} react-active`}`}
          onClick={() => {
            if (!this.checkDisabledSchedule(playtime)) {
              handleClick();
            }
          }}
          style={active
            ? {
              color: bColor,
              backgroundColor: color,
              maxWidth,
              borderColor: color,
            } : {
              color,
              backgroundColor: bColor,
              maxWidth,
              borderColor: color,
            }
          }
        >
          {playtime}
        </button>
      </div>
    );
  }
}

PurchaseModal.propTypes = {
  brandClass: PropTypes.string.isRequired,
  maxWidth: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  bColor: PropTypes.string.isRequired,
  playtime: PropTypes.string.isRequired,
  active: PropTypes.bool,
  inverz: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  cinemas: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string,
  })),
  hours: PropTypes.number,
  minutes: PropTypes.number,
  selectedDate: PropTypes.string.isRequired,
};

PurchaseModal.defaultProps = {
  active: false,
  inverz: false,
  cinemas: null,
  hours: new Date().getHours(),
  minutes: new Date().getMinutes(),
};

export default PurchaseModal;
